export function isDynamicFormGroupConfig(options) {
  return options && !!options['classValidatorOptions'];
}
export function isLegacyOrOpts(options) {
  return options && (!!options['validator'] || !!options['asyncValidator']);
}
export function isAbstractControlOptions(options) {
  return options && (!!options.validators || !!options.asyncValidators || !!options.updateOn);
}